/* Sale countdown bar + ship-date copy (v49).
   The cart-drawer "Track your order" note was removed: the drawer is for
   checking out, and that information already lives on the shipping section
   and the Track page. Everything else unchanged. */
(function(){
var SHIP_DATE='2026-10-05';
var LONG='Monday, October 5';
var SHORT='Oct 5';
var cfg=document.getElementById('ice-countdown-config');
var END=new Date(cfg?cfg.dataset.deadline:'2026-10-31T23:59:00Z');
if(!Number.isFinite(END.getTime()))END=new Date(0);
var RULES=[
[/Ships in 1\s*[\u2013-]\s*2 (business )?days/gi,'Ships '+SHORT],
[/Arrives in [56]\s*[\u2013-]\s*(8|10) (business )?days/gi,'Arrives before ski season'],
[/(Orders|Every order)( is| are)? (packed and )?(shipped|dispatched|ship)( out)? within 1\s*[\u2013-]\s*2 business days/gi,'Every order placed now ships '+LONG],
[/(ship|ships|shipped|dispatch|dispatched)( out)? (with)?in 1\s*[\u2013-]\s*2 business days/gi,'$1 on '+LONG],
[/within 1\s*[\u2013-]\s*2 business days/gi,'on '+LONG],
[/5\s*[\u2013-]\s*8 business days/gi,'6\u201310 business days']
];
function rewrite(root){
if(!root)return;
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);var n;
while((n=w.nextNode())){
if(n.parentNode&&n.parentNode.closest&&n.parentNode.closest('#if-shipbar'))continue;
var t=n.nodeValue;if(!t||t.length<6)continue;var o=t;
for(var i=0;i<RULES.length;i++)t=t.replace(RULES[i][0],RULES[i][1]);
if(t!==o)n.nodeValue=t;
}}
function css(){
if(document.getElementById('if-cd-css'))return;
var s=document.createElement('style');s.id='if-cd-css';
s.textContent='[data-launch-timer][hidden]{display:none!important}@media(prefers-reduced-motion:reduce){.if-cd-num.tick,.if-cd-dot{animation:none!important}}'+
'@keyframes ifcdTick{0%{transform:translateY(-38%);opacity:0}100%{transform:translateY(0);opacity:1}}'+
'@keyframes ifcdPulse{0%{box-shadow:0 0 0 0 rgba(255,77,20,.8)}70%{box-shadow:0 0 0 7px rgba(255,77,20,0)}100%{box-shadow:0 0 0 0 rgba(255,77,20,0)}}'+
'.if-cd-num{display:inline-block}.if-cd-num.tick{animation:ifcdTick .38s cubic-bezier(.2,.8,.2,1)}.if-cd-dot{animation:ifcdPulse 1.6s infinite}'+
'cart-drawer [data-if-shipnote]{display:none!important}';
document.head.appendChild(s);
}
function pad(v){return (v<10?'0':'')+v;}
function cell(id,label,hot){
return '<span style="display:inline-flex; align-items:baseline; gap:2px;"><span style="display:inline-block; overflow:hidden; background:'+(hot?'#FF4D14':'#232A33')+'; border-radius:6px; padding:3px 5px 1px; min-width:30px; text-align:center;"><span id="'+id+'" class="if-cd-num" style="font-family:Bebas Neue,sans-serif; font-size:19px; line-height:1; color:#fff; letter-spacing:0.5px;">00</span></span><span style="font-size:9.5px; font-weight:800; color:#8892A0;">'+label+'</span></span>';
}
var last={};
function tick(){
var ms=END-new Date();if(ms<0)ms=0;
var header=document.getElementById('if-shipbar');if(header&&ms===0){var title=header.querySelector('[data-sale-title]');if(title)title.textContent='FREAK SEASON';var label=header.querySelector('[data-countdown-label]');if(label)label.textContent=cfg?cfg.dataset.ended:'Countdown ended';}
var vals={'if-cd-d':Math.floor(ms/86400000),'if-cd-h':Math.floor(ms/3600000)%24,'if-cd-m':Math.floor(ms/60000)%60,'if-cd-s':Math.floor(ms/1000)%60};
for(var k in vals){var e=document.getElementById(k);if(!e)continue;var v=pad(vals[k]);if(last[k]!==v){e.textContent=v;e.classList.remove('tick');void e.offsetWidth;e.classList.add('tick');last[k]=v;}}
}
function bar(){
var root=document.getElementById('if');
if(!root||document.getElementById('if-shipbar'))return;
css();
var hdr=root.querySelector('header');
var b=document.createElement('div');
b.id='if-shipbar';b.setAttribute('role','region');b.setAttribute('aria-label','Sale countdown');
b.setAttribute('style','background:#12161C; color:#fff; padding:10px 12px; text-align:center; font-family:Barlow,sans-serif; border-bottom:3px solid #FF4D14;');
b.innerHTML='<div style="display:flex; align-items:center; justify-content:center; gap:8px; flex-wrap:wrap; font-family:Bebas Neue,sans-serif; font-size:clamp(16px,4.2vw,20px); letter-spacing:1.1px; line-height:1.1;"><span class="if-cd-dot" style="width:7px; height:7px; border-radius:50%; background:#FF4D14; display:inline-block;"></span><span><span style="color:#FF4D14;" data-sale-title>FREAK SEASON SALE</span></span></div>'+
'<div data-launch-timer style="display:flex; align-items:center; justify-content:center; gap:7px; flex-wrap:wrap; margin-top:6px; font-size:12px; color:#C3CBD3;"><span data-countdown-label style="font-weight:700;">Sale ends in</span>'+cell('if-cd-d','d')+cell('if-cd-h','h')+cell('if-cd-m','m')+cell('if-cd-s','s',true)+'</div><div data-launch-done hidden style="font-size:13px;margin-top:8px;">DISPATCH DAY &middot; <a href="/pages/track" style="color:#fff!important;">Track your order &rarr;</a></div>';
if(hdr&&hdr.parentNode===root){root.insertBefore(b,hdr.nextSibling);}else{root.insertBefore(b,root.firstChild);}
var label=b.querySelector('[data-countdown-label]');if(label&&cfg)label.textContent=cfg.dataset.label;
tick();
}
function run(){
bar();
if(Date.now()<Date.parse('2026-10-05T18:00:00Z')){rewrite(document.getElementById('if'));rewrite(document.getElementById('if-sticky'));rewrite(document.querySelector('cart-drawer'));}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setInterval(run,800);
setInterval(tick,1000);
})();
